'use strict';

var DemandTransparencyForecastProfileMappedTransformerFactory = function DemandTransparencyForecastProfileMappedTransformerFactory(DataTransformer) {
  function DemandTransparencyForecastProfileMappedTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'demand-transparency-forecast-profile-mapped';
    this.targetType = 'demand-transparency-forecast-profile-chart';
    this.priority = 1;
  }
  DemandTransparencyForecastProfileMappedTransformer.prototype = Object.create(DataTransformer.prototype);
  DemandTransparencyForecastProfileMappedTransformer.constructor = DemandTransparencyForecastProfileMappedTransformer;
  return DemandTransparencyForecastProfileMappedTransformer;
};
DemandTransparencyForecastProfileMappedTransformerFactory.$inject = ['DemandTransparencyForecastProfileRegularTransformerFactory'];
module.exports = DemandTransparencyForecastProfileMappedTransformerFactory;